// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const BitwardenIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <path
      fill="#175DDC"
      d="M18.3 13.83V5.5H12v14.8a20 20 0 0 0 3-1.78q3.3-2.4 3.3-4.69m2.7-10v10a6 6 0 0 1-.47 2.22q-.47 1.1-1.17 1.96t-1.66 1.66a19 19 0 0 1-3.48 2.35 25 25 0 0 1-1.85.9A1 1 0 0 1 12 23a1 1 0 0 1-.37-.08 17 17 0 0 1-1.85-.9q-.88-.48-1.7-1.01-.82-.54-1.78-1.34-.96-.81-1.66-1.66a8 8 0 0 1-1.17-1.96A6 6 0 0 1 3 13.83v-10q0-.33.27-.58A1 1 0 0 1 3.9 3h16.2a1 1 0 0 1 .63.25q.27.25.27.58"
    />
  </svg>,
  "Bitwarden",
);
export default BitwardenIcon;
